<template>
    <div class="container_view">
        <v-card class="content_card" elevation="10" variant="flat">
            <div>
                <header>
                    <v-card-title> Gestiones </v-card-title>
                    <v-divider class="mx-3"></v-divider>
                </header>
            </div>


            <div class="content_accion">
                <div>
                    <v-text-field
                        v-model="search"
                        label="Búsqueda"
                        prepend-inner-icon="mdi-magnify"
                        single-line
                        variant="outlined"
                        hide-details
                        class="filter">
                    </v-text-field>
                </div>
                <div>
                    <v-btn
                        :to="{ name: 'management-search' }"
                        variant="outlined"
                        color="indigo-darken-3"
                        class="mr-2"
                        prepend-icon="mdi-arrow-left">
                        Nueva búsqueda
                    </v-btn>
                    <v-btn 
                        icon="mdi-reload" 
                        size="small" 
                        variant="outlined" 
                        color="indigo-darken-3" 
                        class="mr-2"
                        @click="searchClient()">
                    </v-btn>
                </div>
            </div> 
            
            <div class="container_table">
                <v-data-table
                    :headers="headers"
                    :items="dataSource.data"
                    :search="search"
                    :loading="isLoading"
                    fixed-header
                    class="content_table"
                    no-data-text="Sin datos para mostrar"
                    loading-text="Cargando información... Espere un momento">
                    <template v-slot:[`item.management_data_changed_at`]="{ item }">
                        <ManagementDate :value="item.management_data_changed_at" />
                    </template>
                    <template v-slot:[`item.managed_at`]="{ item }">
                        <ManagementDate :value="item.managed_at" kind="processed" />
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                        <td>
                            <v-btn 
                                block 
                                color="indigo-darken-3" 
                                rounded="xl" 
                                class="text-none elevation-0"
                                @click="access(item)">
                                Acceder
                            </v-btn>
                        </td>
                    </template>
                </v-data-table>
            </div>
        </v-card>
        <SnackbarComponent :value="snackbarData"/>
    </div>
</template>

<script>
    import { EncryptService } from '@/services/EncryptService'
    import { ManagementsService } from '@/services/ManagementsService'
    import ManagementDate from '@/components/managements/ManagementDate.vue'
    import SnackbarComponent from '@/components/Snackbar';
    import { ResourcesService } from '@/services/ResourcesService';    
    import { useUiStore } from '@/stores/ui'

    export default {
        name: 'SearchManagementView',
        props: {
            msg: String
        },
        components: {
            ManagementDate,
            SnackbarComponent
        },
        data() {
            return {
                test: '',
                isLoading: false,
                search: '',
                dataSource: {                    
                    data: [], 
                },
                date: '',
                type: '',
                snackbarData: {
                    openSnackbar: false,
                    description: '' 
                },
                tipoCartera:'',               
            }
        },
        computed:{
            ui() {
                const store = useUiStore()
                return store.ui;
            },
            headers() {
                const info = this.ui?.managements;
                if (!info) return []
                return [
                    { align: 'start', key: 'id_cliente', title: info.informacionGeneral.id_cliente },
                    { key: 'nombre', title: 'Titular' },
                    { key: 'nombre_aval', title: 'Aval' },
                    { key: 'cartera', title: 'Cartera' },
                    { key: 'total', title: info.pago.total },
                    { key: 'despacho', title: info.informacionGeneral.despacho },
                    { key: 'management_data_changed_at', title: 'Último Cambio' },
                    { key: 'managed_at', title: 'Última Carga' },
                    { key: 'actions', title: 'Acciones'}
                ]
            }
        },
        async mounted() {
            const store = useUiStore()
            if (Object.keys(store.ui).length === 0) {
                await store.cargarVocabulario()
            }
        },
        async created() {
            let params = this.$route.params.form
            let strParams = await EncryptService.decrypt(params)
            this.tipoCartera = await EncryptService.decrypt(localStorage.getItem('TIPO_CARTERA'))
            let form = JSON.parse(strParams);
            this.date = form.dato
            this.type = form.tipo

            const store = useUiStore()
            if (Object.keys(store.ui).length === 0) {
                await store.cargarVocabulario()
            }

            await this.searchClient()
        },
        methods: {

            searchClient: async function () {
                this.isLoading = true
                const ENC_DATA = await EncryptService.encrypt(this.date)
                await ManagementsService.searchClientByOpc(this.type, ENC_DATA).then(
                    (responseData) => {
                        if (!responseData.error) {
                            for (const element of responseData.response) {
                                element.nombre_aval = element.nombre_aval === null ? 'N/A' : element.nombre_aval
                                element.cartera = element.cartera === null ? 'N/A' : element.cartera
                                element.despacho = element.despacho === null ? 'N/A' : element.despacho
                                element.total = element.total === null ? 'N/A' : element.total
                                if (element.total !== 'N/A') {
                                    element.total = ResourcesService.moneyFormat(element.total)
                                }

                                /*if(this.tipoCartera === 'TOTALPLAY' && element.despacho ){
                                    
                                    let fecha = this.compararConHoy(element.despacho)
                                    element.despacho = fecha;
                                }*/
                            }
                            this.dataSource.data = responseData.response
                        } else {
                            this.snackbarData.description = responseData.msg
                            this.snackbarData.openSnackbar = true
                            this.$router.push('/SGCCV/management')
                        }
                    }
                )
                this.isLoading = false
            },

            access: async function (item) {
                const form = {
                    id: item.id_cliente
                }
                const strForm = JSON.stringify(form)
                const encForm = await EncryptService.encrypt(strForm)
                this.$router.push(`/SGCCV/access-search-management/${encForm}/general`)
                
            },
            esFechaValida: function(valor) {
                const fecha = new Date(valor);
                return fecha instanceof Date && !isNaN(fecha.getTime());
            },

            compararConHoy: function(valor) {
                if (!this.esFechaValida(valor)) return "N/A";

                const fechaRecibida = new Date(valor);
                const hoy = new Date();

                // Limpiar hora para comparar solo fecha (opcional)
                hoy.setHours(0, 0, 0, 0);
                fechaRecibida.setHours(0, 0, 0, 0);

                if (fechaRecibida < hoy) return `${fechaRecibida} - Activa`;
                if (fechaRecibida > hoy) return `${fechaRecibida} - Inactiva`;
                return `${fechaRecibida} - Activa`;
            }

        },
    }
</script>

<style scoped>

    .content_accion {
        padding-bottom: 10px !important;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px;
    }

    .filter {
        width: 300px;
    }

    .content_table {
        overflow: auto;
    }
</style>